import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://crypto-expense-management-backend.onrender.com';

// Types
export interface Expense {
  id: number;
  title: string;
  description?: string;
  amount: number;
  currency: string;
  usd_amount?: number;
  time: string; // ISO datetime string
  category_id?: number;
  policy_id?: number;
  category_name?: string; // Added
  policy_name?: string; // Added
  vendor?: string;
  invoice_number?: string;
  expense_type?: string; // Added
  location?: string; // Added
  status: 'draft' | 'submitted' | 'approved' | 'rejected' | 'sent_back' | 'paid';
  source: 'eth' | 'base' | 'solana' | 'pyusd' | 'fiat';
  created_at: string;
  updated_at: string;
  submitted_at?: string; // Added
  approved_at?: string; // Added
  user_id: number;
  org_id: number;
  expense_report_id?: number;
  receipt_id?: number; // Associated receipt ID
  receipt_url?: string; // Receipt URL
  reimbursement_status?: string; // Added
  reimbursement_amount?: number; // Added
  reimbursement_tx_hash?: string; // Added
}

export interface ExpenseCreate {
  title: string;
  description?: string;
  amount: number;
  currency: string;
  usd_amount?: number;
  time: string; // ISO datetime string
  category_id?: number;
  policy_id?: number;
  vendor?: string;
  invoice_number?: string;
  source: 'eth' | 'base' | 'solana' | 'pyusd' | 'fiat';
  expense_type?: 'REGULAR';
  user_id: number;
  org_id: number;
  receipt_id?: number;
}

export interface ExpenseUpdate {
  title?: string;
  description?: string;
  amount?: number;
  currency?: string;
  time?: string; // Changed from expense_date to time
  category_id?: number;
  policy_id?: number;
  vendor?: string;
  invoice_number?: string; // Changed from invoice_id to invoice_number
  receipt_id?: number; // Allow attaching receipts to crypto-created expenses
}

// API Service
export class ExpenseService {
  static async createExpense(expenseData: ExpenseCreate): Promise<Expense> {
    const response = await axios.post(`${API_BASE_URL}/api/v1/expenses/`, expenseData);
    return response.data;
  }

  static async getExpenses(skip: number = 0, limit: number = 100): Promise<Expense[]> {
    const response = await axios.get(`${API_BASE_URL}/api/v1/expenses/`, {
      params: { skip, limit }
    });
    return response.data;
  }

  static async getExpense(id: number): Promise<Expense> {
    const response = await axios.get(`${API_BASE_URL}/api/v1/expenses/${id}`);
    return response.data;
  }

  static async updateExpense(id: number, expenseData: ExpenseUpdate): Promise<Expense> {
    const response = await axios.put(`${API_BASE_URL}/api/v1/expenses/${id}`, expenseData);
    return response.data;
  }

  static async deleteExpense(id: number): Promise<void> {
    await axios.delete(`${API_BASE_URL}/api/v1/expenses/${id}`);
  }

  static async submitExpense(id: number): Promise<any> {
    const response = await axios.post(`${API_BASE_URL}/api/v1/expense-workflows/expenses/${id}/submit`);
    return response.data;
  }

  static async searchExpenses(searchParams: {
    title?: string;
    vendor?: string;
    status?: string;
    start_date?: string;
    end_date?: string;
    skip?: number;
    limit?: number;
  }): Promise<Expense[]> {
    const response = await axios.post(`${API_BASE_URL}/api/v1/expenses/search`, searchParams);
    return response.data;
  }
}
